import React, { useEffect, useState } from 'react';
import { FaCheck, FaChevronRight, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { getSearch } from '../../services/item';
import { linkWithMJparam } from '../../utils/roles';
import { canUseMjForItem, isMjForItem } from '../../utils/auth';
import { InputSimple } from '../form/input.Simple';
import { ModalGlobal } from '../modal/modal.Global';
import { useSelector } from 'react-redux';
import { isTabCampaignAccessible } from '../../utils/item';

export const SearchModal = props => {
  const { item } = props;
  const [searchedItemsList, setSearchedItemsList] = useState([]);
  const listCampaignsId = useSelector(state => state.global.listCampaignsId);
  const items = useSelector(state => state.items);
  const canMj = isMjForItem(item, items) || canUseMjForItem(item, items);
  const mjQuery = isMjForItem(item, items) ? `?${linkWithMJparam()}` : '';
  const [searchIn, setSearchIn] = useState({
    type: false,
    universe: true,
    world: true,
    campaign: false,
  });

  const search = async value => {
    const res = await getSearch(value, item, searchIn, listCampaignsId);
    if (Array.isArray(res)) {
      const filtered = res.filter(
        searchItem =>
          searchItem?.type !== 'tab' ||
          isTabCampaignAccessible(searchItem, items, listCampaignsId)
      );
      setSearchedItemsList(filtered);
    } else {
      setSearchedItemsList([]);
    }
  };

  useEffect(() => {
    if (canMj === false) {
      setSearchIn({
        type: undefined,
        universe: true,
        world: true,
        campaign: false,
      });
    }
    if (canMj === false && item.type === 'campaign') {
      // setSearchIn(prev => ({ ...prev, campaign: item?._id }));
    } else if (item?.type === 'world') {
      setSearchIn(prev => ({ ...prev, world: item?._id }));
    } else if (item?.type === 'universe') {
      setSearchIn(prev => ({ ...prev, universe: item?._id }));
    }
  }, [item, canMj]);

  return (
    <ModalGlobal
      title='Search'
      idToOpen={'search'}
    >
      <div
        className='flex flex-wrap items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary-d py-1 px-2 rounded shadow text-contrast'
        style={{ width: 600 }}
      >
        <div
          className='flex gap-1 items-center w-full'
          onClick={() =>
            setSearchIn(prev => {
              return { ...prev, campaign: !prev.campaign };
            })
          }
        >
          {searchIn.campaign ? <FaTimes /> : <FaCheck />}recherche globale
        </div>
        <InputSimple
          placeholder='chercher un item'
          onChange={e => search(e.target.value)}
          onBlur={() => null}
        />

        <div className='w-full'>
          {searchedItemsList.map(searchItem => (
            <div
              key={searchItem._id}
              className='flex gap-1 items-center'
            >
              <div className='flex-1'>{searchItem.label}</div>
              {(isMjForItem(searchItem, items) ||
                canUseMjForItem(searchItem, items)) && (
                <Link to={`../../item/${searchItem._id}${mjQuery}`}>
                  <FaChevronRight />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </ModalGlobal>
  );
};
